<template>
  <div class="flex items-start flex-col w-full">
    <div class="flex flex-wrap w-full items-center gap-2.5" v-if="state">
      <div>
        <el-tooltip
          content="Пропустить (Alt + V)"
          :show-after="300"
          placement="top"
          :disabled="batch_block"
        >
          <el-checkbox :disabled="batch_block" border v-model="form.skip"
            >Пропустить</el-checkbox
          >
        </el-tooltip>
      </div>
      <el-tooltip
        content="Сохранить (Alt + S)"
        placement="top"
        :show-after="300"
        :disabled="notAllowed || textSkipAccess || batch_block"
      >
        <el-button
          :disabled="notAllowed || textSkipAccess || batch_block"
          type="primary"
          plain
          @click="saveChat"
          >Сохранить</el-button
        ></el-tooltip
      >
    </div>
    <div class="w-full mt-2">
      <span v-if="isVerifiedState">Верификация</span>
      <el-popover
        v-if="canAddToDictionary"
        ref="selectionPopover"
        v-model:visible="popoverVisible"
        :virtual-ref="virtualRef"
        virtual-triggering
        width="220"
        placement="bottom"
        popper-class="m-0 mt-2.5 p-0"
      >
        <div class="flex flex-col items-center w-full">
          <div
            @click="addToDictionary('kz')"
            class="flex justify-center w-full p-2 rounded border border-solid border-transparent cursor-pointer hover:bg-gray-100 hover:border-gray-200"
          >
            Добавить в словарь kaz
          </div>
          <div
            @click="addToDictionary('ru')"
            class="flex justify-center w-full p-2 rounded border border-solid border-transparent cursor-pointer hover:bg-gray-100 hover:border-gray-200"
          >
            Добавить в словарь rus
          </div>
          <div
            @click="copySelectedText"
            class="flex w-full p-2 px-4 rounded border border-solid border-transparent cursor-pointer hover:bg-gray-100 hover:border-gray-200"
          >
            Скопировать текст
          </div>
        </div>
      </el-popover>
      <el-input
        ref="transcribe-input"
        id="transcribe-input"
        class="mt-2"
        style="font-size: 16px"
        input-style="height: 80px;max-height: 80px; resize: none; overflow-wrap: break-word; word-break: break-word;"
        type="textarea"
        :disabled="form.skip || viewMode || batch_block"
        v-model="form.text"
        @input="filterInput"
        @keydown="handleKeydown"
        @contextmenu="handleRightClick"
      />
      <div
        v-if="invalidWords && invalidWords.length > 0"
        class="text-red-500 mt-1 break-words"
        style="font-size: 16px"
      >
        {{ invalidWords }}<span class="ml-0.5">не найдены в словаре.</span>
      </div>
      <span
        v-if="notAllowed && !viewMode"
        class="text-red-500"
        style="font-size: 16px"
      >
        Недопустимые символы</span
      >
      <span
        v-else-if="textSkipAccess && !viewMode"
        class="text-xs text-red-500"
      >
        Введите текст или выберите Пропустить
      </span>
      <div v-if="isVerifiedState" class="mt-5">
        <span>Разметка</span>
        <el-input
          class="mt-2"
          style="font-size: 16px"
          input-style="height: 80px;max-height: 80px; resize: none; overflow-wrap: break-word; word-break: break-word;"
          type="textarea"
          :disabled="true"
          v-model="marked_up.text"
        />
      </div>
    </div>
  </div>
</template>
<script>
import apiClient from "@/api/api-client";
import { ElInput, ElPopover, ElMessage } from "element-plus";
import { addWordToDictionary, getDictionaryResult } from "@/api/dictionary";

export default {
  name: "FillingFormFullAudio",
  components: { ElInput, ElPopover },
  props: {
    lang: {
      type: String,
      default: "kz",
    },
    lines: {
      type: Array,
    },
    lineIndex: {
      type: Number,
    },
    markedUp: {
      type: Array,
    },
    state: {
      type: Boolean,
    },
    isVerifiedState: {
      type: Boolean,
    },
    viewMode: {
      type: Boolean,
    },
    verifierCheckWords: {
      type: Boolean,
    },
    batch_block: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        text: "",
        skip: false,
      },
      marked_up: {
        text: "",
      },
      invalidWords: [],
      debounce: null,
      isButtonDisabled: true,
      editingLineIndex: null,

      // highlight text and save to dictionary
      popoverVisible: false,
      virtualRef: null,
      selectedText: "",
    };
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
    canAddToDictionary() {
      return this.user.scopes.includes("verifier");
    },
    notAllowed() {
      if (this.form.text === "") {
        return false;
      }
      const allowedSymbolsRegex =
        /^[АӘБВГҒДЕЁЖЗИЙКҚЛМНҢОӨПРСТУҮҰФХҺЦЧШЩЪЫІЬЭЮЯаәбвгғдеёжзийкқлмнңоөпрстуүұфхһцчшщъыіьэюя\s\-.*?+]+$/u;
      const isNotAllowed = !allowedSymbolsRegex.test(this.form.text);

      this.$emit("not-allowed-changed", isNotAllowed);

      return isNotAllowed;
    },
    textSkipAccess() {
      const access = this.form.text.trim() === "" && this.form.skip === false;
      this.$emit("fragment-access-changed", access);
      return access;
    },
  },
  watch: {
    lineIndex: {
      immediate: true,
      handler() {
        this.updateCurrentLine();
      },
    },
    lines: {
      immediate: true,
      handler() {
        this.updateCurrentLine();
      },
    },
    markedUp: {
      immediate: true,
      handler() {
        this.updateCurrentLine();
      },
    },
  },
  mounted() {
    this.focusInput();
    this.updateCurrentLine();
    window.addEventListener("keydown", this.handleSave);
    window.addEventListener("keydown", this.handleSkip);
    if (!this.notAllowed && this.state && !this.batch_block) {
      this.saveInterval = setInterval(() => {
        if (!this.notAllowed && this.state) {
          ElMessage({
            message: "Автосохранение",
            type: "info",
            customClass: "my-custom-message",
            duration: 3000,
          });
          this.saveChat();
        }
      }, 30000);
    }
  },
  beforeUnmount() {
    if (this.saveInterval) {
      clearInterval(this.saveInterval);
    }
    window.removeEventListener("keydown", this.handleSave);
    window.removeEventListener("keydown", this.handleSkip);
  },
  methods: {
    updateCurrentLine() {
      const arrayIndex = (this.lineIndex || 1) - 1;

      if (this.lines && this.lines.length > arrayIndex) {
        this.form.text = this.lines[arrayIndex].text || "";
        this.form.skip = this.lines[arrayIndex].skip || false;
      }

      if (this.markedUp && this.markedUp.length > arrayIndex) {
        this.marked_up.text = this.markedUp[arrayIndex].text || "";
      } else {
        this.marked_up.text = "";
      }

      this.invalidWords = [];
      if (this.verifierCheckWords) this.validateAndSave();
    },
    getCurrentInput() {
      return {
        text: this.form.text || "",
        skip: this.form.skip || false,
        index: this.lineIndex,
      };
    },
    focusInput() {
      this.$refs["transcribe-input"].focus();
    },
    filterInput() {
      const validationSymbols =
        /^[АӘБВГҒДЕЁЖЗИЙКҚЛМНҢОӨПРСТУҮҰФХҺЦЧШЩЪЫІЬЭЮЯаәбвгғдеёжзийкқлмнңоөпрстуүұфхһцчшщъыіьэюя\s\-.*?+]*$/u;

      this.form.text = this.form.text
        .split("")
        .filter((char) => validationSymbols.test(char))
        .join("");
    },
    async validateAndSave() {
      this.invalidWords = [];
      const text = this.form.text;
      try {
        const response = await apiClient.get(`/word`, {
          params: { texts: text },
        });
        if (response && response.data && !response.data._success) {
          this.invalidWords = response.data.err_words || [];
        }
      } catch (error) {
        console.error(error);
        this.invalidWords = [];
      }
    },
    insertFormData({ text, skip }) {
      this.form = { text, skip };
    },
    saveChat() {
      if (!this.notAllowed && !this.textSkipAccess && !this.batch_block) {
        this.$emit("save:chat", this.form.text, this.form.skip, this.lineIndex);
      }
      this.validateAndSave();
    },
    triggerSaveChat() {
      this.saveChat();
    },
    handleKeydown(event) {
      if (
        !event.shiftKey &&
        event.keyCode === 13 &&
        !this.notAllowed &&
        !this.textSkipAccess
      ) {
        event.preventDefault();
        this.saveChat();
      } else if ((event.altKey || event.metaKey) && event.code === "KeyT") {
        event.preventDefault();

        const input = this.$refs["transcribe-input"].$refs.textarea;
        if (!input) return;

        const cursorPos = input.selectionStart;
        const text = this.form.text || "";

        this.form.text = text.slice(0, cursorPos) + "ё" + text.slice(cursorPos);

        this.$nextTick(() => {
          input.selectionStart = input.selectionEnd = cursorPos + 1;
        });
      }
    },
    handleSave(event) {
      if ((event.altKey || event.metaKey) && event.code === "KeyS") {
        event.preventDefault();
        this.saveChat();
      }
    },
    handleSkip(event) {
      if ((event.altKey || event.metaKey) && event.code === "KeyV") {
        event.preventDefault();
        this.form.skip = !this.form.skip;
      }
    },
    createVirtualRef(x, y) {
      return {
        getBoundingClientRect() {
          return {
            width: 0,
            height: 0,
            top: y,
            bottom: y,
            left: x,
            right: x,
          };
        },
      };
    },
    handleRightClick(event) {
      if (!this.canAddToDictionary) {
        //for others native menu
        return;
      }

      event.preventDefault();

      const textarea = this.$refs["transcribe-input"].$refs.textarea;
      if (!textarea) return;

      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      const selectedText = textarea.value.substring(start, end).trim();

      if (!selectedText) {
        this.popoverVisible = false;
        return;
      }

      this.selectedText = selectedText;

      const { clientX: x, clientY: y } = event;
      this.virtualRef = this.createVirtualRef(x, y);

      this.popoverVisible = true;
    },
    async addToDictionary(lang) {
      if (!this.selectedText) return;

      const normalizedSelected = this.selectedText.replace(/\s+/g, " ").trim();

      const payload = {
        text: normalizedSelected,
        lang,
      };

      try {
        const response = await getDictionaryResult(payload);

        const alreadyExists = response?.success_words?.some(
          (item) => item.text.replace(/\s+/g, " ").trim() === normalizedSelected
        );
        const languageLabel = lang === "ru" ? "rus" : "kaz";

        if (alreadyExists) {
          ElMessage({
            message: `Слово "${normalizedSelected}" уже есть в словаре ${languageLabel}`,
            type: "warning",
            customClass: "my-custom-message",
            duration: 3000,
          });
        } else {
          await addWordToDictionary(payload);
        }
      } catch (error) {
        console.error(error);
        ElMessage.error("Ошибка при проверке словаря");
      } finally {
        this.popoverVisible = false;
      }
    },
    copySelectedText() {
      if (!this.selectedText) return;

      navigator.clipboard
        .writeText(this.selectedText)
        .then(() => {
          ElMessage({
            message: `Текст "${this.selectedText}" скопирован`,
            type: "success",
            duration: 2000,
          });
        })
        .catch((err) => {
          console.error("Ошибка копирования:", err);
          ElMessage.error("Не удалось скопировать текст");
        })
        .finally(() => {
          this.popoverVisible = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped></style>
